import React from 'react';
import Desktop from './desktop';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Desktop />} />
        
      </Routes>
    </Router>
  );
}

export default App;
